import { Grid2 } from "@mui/material";
import React, { useEffect } from "react";
import Custom from "./Custom";
import custom from "../../../Images/Service/customSolution.json";
import application from "../../../Images/Service/application.json";
import oracle from "../../../Images/Service/oracle.json";
import cloud from "../../../Images/Service/cloud.json";
import saas from "../../../Images/Service/saas.json";
import sharepoint from "../../../Images/Service/sharepoint.json";
import saleforce from "../../../Images/Service/saleforce.json";
import cyber from "../../../Images/Service/cyber.json";
import testing from "../../../Images/Service/Testing.json";
// import aboutUsBg from "../../../Images/aboutUsBg.jpg";
import { useSearchParams } from "react-router-dom";
import { commonCss } from "../../../CssStyle/commonCss";

const Service = () => {
    const [searchParams,setSearchParams]=useSearchParams()
    useEffect(() => {
        const element = document.getElementById(searchParams.get("serviceTitle"));
        if (element) {
          element.scrollIntoView({behavior: "smooth" });
        }
      }, [searchParams.get("serviceTitle")]);

    const customSolutionList=["Digital Transformation","Digitalization","Enterprise Solutions","Upgrade","Web & Mobile Solutions","Maintenance","Applications","Cloud Solutions", "Saas Solutions"]
    const applicationList=["Custom Web & Mobile Apps","Enterprise Mobility","ECommerce Apps"]
    const cloudList=["Enterprise Cloud Development","Cloud Integration","Cloud Optimization"]
    const saasList=["Custom SaaS","Implementation","SaaS for Startups","Integration","SaaS for Enterprises","Optimization"]
    const oracleList=["Oracle Fusion Cloud","Oracle E-Business Suite","Oracle Managed Services","Linux Managed Services"]
    const sharepointList=["SharePoint On-Premise customization and development","Document Management system","Project Management","Library Management","Intranet Applications","SharePoint designer workflows","SharePoint web-part development","Power automate development","PowerBI dashboards","SharePoint online apps","SharePoint management"]
    const saleforceList=["Salesforce Implementation","Salesforce Customization","Salesforce Integration","Salesforce Support and Maintenance","Salesforce Training","SharePoint designer workflows","Salesforce Analytics and Reporting","Salesforce Marketing Cloud"]
    const cyberList=["Cybersecurity Risk Assessment & Gap Analysis","Managed Security Services (MSS)","Network and Infrastructure Security","Cloud Security Services","Endpoint Security","Identity and Access Management (IAM)","Data Protection and Encryption","Incident Response and Digital Forensics","Security Awareness & Training"]
    const testAutomationList=["Automation Testing Services","Performance Testing"]
  return (

    <Grid2 container spacing={"2rem"} >
      <Custom
      spacing={{xs:"1rem",md:"1rem"}}
      displayDesc={true}
        direction={"row"}
        lottieImage={custom}
        title={"Custom Solution"}
        subtitle={"Revolutionizing Businesses with Next-Gen Digital Solutions"}
        description={"Grow Fast, Think Smart, and Succeed Better Efficient Solutions with Minimal Risk."}
        listTitle={"Our customized Custom Solutions :"}
        listName={customSolutionList}
        width={"40%"}
        id="custom"
        styleSX={{background:`url(/Images/aboutUsBg.jpg)`,backgroundSize: "cover",padding:{xs:"1.5rem",md:"3rem"},}}
        // mt={{xs:"40%",sm:"30%",md:"15%",lg:"13%",xl:"5%"}}
        mt={"13vh"}
      />
       <Custom
       spacing={{xs:"5rem",md:"6rem"}}
        direction={"row-reverse"}
        lottieImage={application}
        title={"APPLICATIONS"}
        subtitle={"Visually Impactful Apps That Empower Your Business."}
       
        listName={applicationList}
        width={"90%"}
        id="application"
        mt={0}
        styleSX={{background:`white`,padding:{xs:"1.5rem",md:"3rem"}}}
      />
       <Custom
       spacing={{xs:"5rem",md:"1rem"}}
        direction={"row"}
        lottieImage={oracle}
        title={"Oracle Cloud"}
        subtitle={"Oracle enables global businesses to streamline operations. We deliver integrated solutions that drive efficiency and growth."}
        readmore={true}
        listName={oracleList}
        navigateLink={"/oracle"}
        width={"90%"}
        id="oracle"
        mt={0}
        styleSX={{background:commonCss.backgroundGray,padding:{xs:"1.5rem",md:"3rem"}}}
      />
       <Custom
       spacing={{xs:"5rem",md:"6rem"}}
        direction={"row-reverse"}
        lottieImage={sharepoint}
        title={"Sharepoint Cloud"}
        subtitle={"We provide ongoing SharePoint support to keep your platform running smoothly and securely."}
        readmore={true}
        listName={sharepointList}
        navigateLink={"/sharepoint"}
        width={"47%"}
        id="sharepoint"
        mt={0}
        styleSX={{background:"white",padding:{xs:"1.5rem",md:"3rem"}}}
      />
      <Custom
       spacing={{xs:"5rem",md:"1rem"}}
        direction={"row"}
        lottieImage={saleforce}
        title={"Salesforce Cloud"}
        subtitle={"We help businesses implement and customize Salesforce to fit their unique needs."}
        readmore={true}
        listName={saleforceList}
        navigateLink={"/saleforce"}
        width={"40%"}
        id="saleforce"
        mt={0}
        styleSX={{background:commonCss.backgroundGray,padding:{xs:"1.5rem",md:"3rem"}}}
      />
      <Custom
      spacing={{xs:"5rem",md:"6rem"}}
        direction={"row-reverse"}
        lottieImage={cyber}
        title={"Cyber Security Services"}
        subtitle={"we provide end-to-end cybersecurity services that help businesses of all sizes stay protected in an increasingly digital and threat-prone world. "}
        navigateLink={"/cybersecurity"}
        readmore={true}
        listName={cyberList}
        width={"40%"}
        id="cyber"
        styleSX={{background:"whte",padding:{xs:"1.5rem",md:"3rem"}}}
        mt={0}
      />
      <Custom
       spacing={{xs:"5rem",md:"1rem"}}
        direction={"row"}
        lottieImage={testing}
        title={"Test Automation"}
        subtitle={"We specialize in delivering reliable and scalable software testing solutions tailored to meet your business needs"}
        readmore={true}
        listName={testAutomationList}
        navigateLink={"/testautomation"}
        width={"100%"}
        id="testautomation"
        mt={0}
        styleSX={{background:commonCss.backgroundGray,padding:{xs:"1.5rem",md:"3rem"}}}
      />
      <Custom
      spacing={{xs:"5rem",md:"6rem"}}
      displayDesc={true}
        direction={"row-reverse"}
        lottieImage={cloud}
        title={"Cloud Solutions"}
        subtitle={"Cloud Solutions Built to Define Your Business"}
        description={"Enhance Agility and Define Your Business with the Right Cloud Solutions."}
        listTitle={"Our Capabilities in Cloud Services :"}
        listName={cloudList}
        width={"90%"}
        id="cloud"
        styleSX={{background:"whte",padding:{xs:"1.5rem",md:"3rem"}}}
        mt={0}
      />
       <Custom
       spacing={{xs:"1rem",md:"6rem"}}
        direction={"row-reverse"}
        displayDesc={true}
        lottieImage={saas}
        title={"SAAS Solutions"}
        subtitle={"Enhance Business Performance with Tailored SaaS."}
         description={"Unlock Efficiency with Scalable SaaS Solutions for Your Team."}
         listTitle={"Our SaaS Solutions :"}
        listName={saasList}
        width={"40%"}
        id="saas"
        styleSX={{background:commonCss.backgroundGray,padding:{xs:"1.5rem",md:"3rem"}}}
        mt={0}
      />
    </Grid2>
    
  );
};

export default Service;
